import { apiClient } from './client'
import type { ApiResponse } from './client'

export interface GoogleAuthStatusResult {
    ProviderEmail: string
    IsConnected: boolean
    AccessTokenExpiresUtc?: string | null
}

export interface GooglePickerTokenResult {
    accessToken: string
    pickerApiKey: string
}

export interface GoogleAuthInitiateResult {
    authorizationUrl: string
}

export const googleAuthApi = {
    /** Get the OAuth authorization URL to open in popup */
    initiate: async (): Promise<ApiResponse<GoogleAuthInitiateResult>> => {
        return apiClient.get('/api/Auth/Google/Initiate')
    },

    /** Check if user has connected their Google account */
    getStatus: async (): Promise<ApiResponse<GoogleAuthStatusResult>> => {
        return apiClient.get('/api/Auth/Google/Status')
    },

    /** Get a fresh access token and Picker API key for the Google Picker */
    getPickerToken: async (): Promise<ApiResponse<GooglePickerTokenResult>> => {
        return apiClient.get('/api/Auth/Google/PickerToken')
    },

    /** Disconnect the user's Google account */
    disconnect: async (): Promise<ApiResponse<void>> => {
        return apiClient.delete('/api/Auth/Google/Disconnect')
    },
}
